import axios from "axios";

const envUrl = process.env.REACT_APP_BACKEND_URL;
export const API = `${envUrl && new URL(envUrl).host === window.location.host ? envUrl : window.location.origin}/api`;

export const authHeaders = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const formatErr = (err, fallback = "Something went wrong.") => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return fallback;
};

/* Compress any raster image to a JPEG data URL under 300 KB; SVG passes through if small enough. */
export const compressImage = (file) =>
  new Promise((resolve, reject) => {
    if (file.type === "image/svg+xml") {
      if (file.size > 300 * 1024) return reject(new Error("This SVG is over 300 KB."));
      const r = new FileReader();
      r.onload = () => resolve(r.result);
      r.onerror = () => reject(new Error("Could not read the file."));
      r.readAsDataURL(file);
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        const scale = Math.min(1, 1200 / Math.max(width, height));
        const draw = (w, h, q) => {
          const canvas = document.createElement("canvas");
          canvas.width = w;
          canvas.height = h;
          canvas.getContext("2d").drawImage(img, 0, 0, w, h);
          return canvas.toDataURL("image/jpeg", q);
        };
        let w = Math.round(width * scale);
        let h = Math.round(height * scale);
        let q = 0.85;
        let out = draw(w, h, q);
        while (out.length * 0.75 > 300 * 1024 && q > 0.35) {
          q -= 0.1;
          out = draw(w, h, q);
        }
        while (out.length * 0.75 > 300 * 1024 && w > 400) {
          w = Math.round(w / 1.5);
          h = Math.round(h / 1.5);
          out = draw(w, h, 0.7);
        }
        if (out.length * 0.75 > 300 * 1024) return reject(new Error("Could not compress this image under 300 KB."));
        resolve(out);
      };
      img.onerror = () => reject(new Error("Could not read this image."));
      img.src = e.target.result;
    };
    reader.onerror = () => reject(new Error("Could not read the file."));
    reader.readAsDataURL(file);
  });

export const newId = () => Math.random().toString(36).slice(2, 10);
